import React from 'react';
import moment from 'moment';
import Container from '../editor/container';
import NewsEditor from '../editor';
import '../editor/styles.css';
import parseContent from '../editor/parseContent';

class Component extends React.Component {
  initialState = {
    modalOpen: false,
    id: false,
    target_role_id: 0,
    target_wids: '',
    target_networks: '',
    content: '',
    contentObj: [],
    mode: 'edit'
  };

  state = this.initialState;

  componentWillMount() {
    this.setState(this.initialState);
    if (this.props.apiState.initial) {
      this.props.api('news/find_by_user');
    }
  }

  save = (e) => {
    e.preventDefault();
    let params = {
      target_role_id: parseInt(this.state.target_role_id),
      target_wids: this.state.target_wids.trim(),
      target_networks: this.state.target_networks.trim(),
      content: JSON.stringify(this.state.contentObj)
    };
    if (this.state.id) params['id'] = this.state.id;
    this.setState({ saving: true });
    this.props.api('news/save', params).then((res) => {
      console.log('res', res);
      if (res && res.result == 1) {
        this.props.api('news/find_by_user');
        this.setState({
          saving: false,
          modalOpen: false,
          id: false,
          target_role_id: 0,
          target_wids: '',
          target_networks: '',
          content: ''
        });
      } else {
        this.setState({ saving: false, error: (res && res.error && res.error.toString()) || res });
      }
    });
  };

  remove = (card) => {
    if (!confirm('Are you sure?')) return;
    this.setState({ saving: true });
    this.props.api('news/remove', { id: card.news_id, remove: true }).then((res) => {
      console.log('res', res);
      if (res && res.result == 1) {
        this.props.api('news/find_by_user');
        this.setState({
          saving: false,
          modalOpen: false
        });
      } else {
        this.setState({ saving: false, error: (res && res.error && res.error.toString()) || res });
      }
    });
  };

  handleChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === 'file' ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    event.preventDefault && event.preventDefault();
  };

  openModal = (card) => {
    let newState = {
      modalOpen: true,
      id: false,
      target_wids: '',
      target_networks: '',
      target_role_id: 0,
      content: '',
      contentObj: {
        type: 'container'
      },
      selected: null
    };
    if (card) {
      newState.id = parseInt(card.news_id || card.id);
      newState.content = card.content;
      newState.contentObj = parseContent(newState.content);
      newState.target_role_id = parseInt(card.target_role_id);
      let wids = card.target_wids;
      let networks = card.target_networks;
      var wids, networks;
      if (wids)
        newState.target_wids = wids
          .substring(1, wids.length - 1)
          .split('|')
          .join(',');
      if (networks)
        newState.target_networks = networks
          .substring(1, networks.length - 1)
          .split('|')
          .join(',');
      console.log({ wids, networks, newState });
    }
    this.setState(newState);
  };

  renderModal() {
    let roleId = this.props.user.role_id;
    let editMode = this.state.mode == 'edit';
    return (
      <form
        class={'modal fade black-overlay ' + (this.state.modalOpen ? 'show d-block' : '')}
        onSubmit={this.save}
      >
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-header'>
              <div class='row pr-3'>
                {roleId >= 2 && (
                  <div class='col-sm row'>
                    <label class='col-sm col-sm-4 col-form-label'>Group</label>
                    <select
                      class='form-control col-sm'
                      name='target_role_id'
                      value={this.state.target_role_id}
                      onChange={this.handleChange}
                    >
                      {roleId >= 4 && <option value='3'>Admins</option>}
                      {roleId >= 3 && <option value='2'>Masters</option>}
                      {roleId >= 2 && <option value='1'>Affiliates</option>}
                      {roleId >= 1 && <option value='10'>Agents</option>}
                      <option value='0'>All</option>
                    </select>
                  </div>
                )}
                <div class='col-sm row'>
                  <label class='col-sm col-sm-4 col-form-label'>Wids</label>
                  <input
                    type='text'
                    class='form-control col-sm'
                    placeholder='wid1,wid2'
                    name='target_wids'
                    value={this.state.target_wids}
                    onChange={this.handleChange}
                  />
                </div>
                {roleId >= 2 && (
                  <div class='col-sm row'>
                    <label class='col-sm col-sm-4 col-form-label mr-2'>Networks</label>
                    <input
                      type='text'
                      class='form-control col-sm'
                      placeholder='wid1,wid2'
                      name='target_networks'
                      value={this.state.target_networks}
                      onChange={this.handleChange}
                    />
                  </div>
                )}
              </div>
            </div>
            <div class='modal-body p-2'>
              <NewsEditor
                data={this.state.contentObj}
                mode={this.state.mode}
                onChange={this.handleChange}
              />
            </div>
            <div class='modal-footer d-block'>
              <div class='row'>
                <div class='col-sm-3'>
                  {this.state.id && (
                    <button
                      type='button'
                      class='btn danger modal-footer-left'
                      onClick={(e) => this.remove(card)}
                    >
                      Remove
                    </button>
                  )}
                </div>
                <div class='col-sm-5 text-center'>
                  <div class='btn-group'>
                    <button
                      class={'btn primary' + (editMode ? ' active' : '')}
                      name='mode'
                      value='edit'
                      onClick={this.handleChange}
                    >
                      Editor
                    </button>
                    <button
                      class={'btn primary' + (!editMode ? ' active' : '')}
                      name='mode'
                      value='render'
                      onClick={this.handleChange}
                    >
                      Preview
                    </button>
                  </div>
                </div>
                <div class='col-sm-4 text-right'>
                  <button
                    type='button'
                    class='btn warning'
                    onClick={(e) => this.setState({ modalOpen: false })}
                  >
                    Cancel
                  </button>
                  <button type='submit' class='btn primary ml-2'>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div>
        {this.props.items.map((card, i) => (
          <div key={card.news_id} class={'news-card box p-2 ' + (i == 0 ? '' : 'mt-3')}>
            <div class='row'>
              <div class='col-sm'>
                <span class='news-card-date'>{moment(card.date * 1000).format('DD MMM YYYY')}</span>
                <span class='news-card-author ml-2'>by {card.author_name || ''}</span>
              </div>
              {(card.wid == this.props.user.aid || this.props.user.role_id >= 4) && (
                <div class='col-sm text-right'>
                  <a class='news-card-edit' onClick={(e) => this.openModal(card)}>
                    edit
                  </a>
                  <a class='news-card-remove ml-2' onClick={(e) => this.remove(card)}>
                    remove
                  </a>
                </div>
              )}
            </div>
            <div class='news-card-content mt-2'>
              <Container
                el={card.contentObj}
                content={card.contentObj.content}
                parent={this}
                root={this}
                onSelect={this.selectGrid}
                mode='render'
              />
            </div>
          </div>
        ))}
        {this.props.user.role_id >= 2 && (
          <div>
            <button class='btn warning' onClick={(e) => this.openModal()}>
              Add
            </button>
            {this.renderModal()}
          </div>
        )}
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    let apiState = state.api['news_find_by_user'] || state.api.initial;
    let items = apiState.items || [];
    items = items.map((item) => {
      if (!item.contentObj) item.contentObj = parseContent(item.content, true);
      return item;
    });
    items = items.filter((item) => item.contentObj.type == 'container');
    return {
      apiState: apiState,
      items: items,
      authorApiState: state.api['news_find_by_author'] || state.api.initial,
      saveApiState: state.api['news_save'] || state.api.initial,
      removeApiState: state.api['news_remove'] || state.api.initial,
      state: state.state['news'] || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('news_find_by_user'),
    changeData: function (data) {
      return function (dispatch) {
        dispatch({
          type: 'api_success',
          key: 'news_find_by_user',
          manual: true,
          data: data
        });
      };
    }
  }
)(Component);
